import React, { Children } from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Purchase'
}, {
  number: '02',
  title: 'Download instantly'
}, {
  number: '03',
  title: 'Open on your iPad'
}, {
  number: '04',
  title: 'Start planning'
}];
export function HowItWorksSection() {
  return <section className="w-full bg-[#EEF3ED] py-24 px-6 md:py-32" data-id="element-133">
      <div className="max-w-6xl mx-auto" data-id="element-134">
        <div className="text-center mb-20" data-id="element-135">
          <span className="text-xs uppercase tracking-[0.2em] text-[#8FAF88] font-medium block mb-4" data-id="element-136">
            How It Works
          </span>
          <h2 className="text-4xl md:text-5xl font-light text-[#2C2C2C]" data-id="element-137">
            Simple. Instant. Seamless.
          </h2>
        </div>

        <div className="relative" data-id="element-138">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-[3.5rem] left-0 w-full h-[1px] bg-[#8FAF88]/20 -z-0" data-id="element-139"></div>

          <motion.div className="grid grid-cols-1 md:grid-cols-4 gap-12 md:gap-6" initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={{
          visible: {
            transition: {
              staggerChildren: 0.2
            }
          }
        }} data-id="element-140">
            {steps.map((step, index) => <motion.div key={index} variants={{
            hidden: {
              opacity: 0,
              y: 30
            },
            visible: {
              opacity: 1,
              y: 0
            }
          }} className="flex flex-col items-center text-center bg-[#EEF3ED] z-10" data-id="element-141">
                <div className="w-28 h-28 rounded-full bg-white flex items-center justify-center mb-6 shadow-sm border border-[#8FAF88]/10" data-id="element-142">
                  <span className="text-4xl font-serif text-[#8FAF88]" data-id="element-143">
                    {step.number}
                  </span>
                </div>
                <h3 className="text-lg font-light uppercase tracking-wide text-[#2C2C2C]" data-id="element-144">
                  {step.title}
                </h3>
              </motion.div>)}
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 1.0,
        duration: 0.8
      }} className="mt-20 text-center space-y-2" data-id="element-145">
          <p className="text-sm text-[#6B8F64] font-medium" data-id="element-146">
            Compatible with GoodNotes and Notability. Apple Pencil recommended.
          </p>
          <p className="text-xs text-[#2C2C2C]/60 uppercase tracking-wider" data-id="element-147">
            Digital product only. No physical item will be shipped.
          </p>
        </motion.div>
      </div>
    </section>;
}